(() => {
  if (!document.documentElement.lang.toLowerCase().startsWith('de')) return;
  let pending = false;
  const words = new Map([['Previous reviews','Vorherige Bewertungen'],['Next reviews','Weitere Bewertungen'],['Write a review','Bewertung schreiben'],['Read more','Mehr lesen'],['Read less','Weniger anzeigen'],['Verified','Verifiziert'],['Let customers speak for us','Was unsere Kunden an uns lieben']]);
  const personalization = [
    ['Choose something...', 'Bitte auswählen'],
    ['Choose something…', 'Bitte auswählen'],
    ['Upload a photo', 'Foto hochladen'],
    ['SWC-GoldPlate', 'Gold'],
    ['SWC-SilverPlate', 'Silber'],
    ['SWC-RoseGoldPlate', 'Roségold'],
    ['Wählen Sie Globus', 'Wähle dein Schneekugelmotiv'],
    ['Wählen Sie Schnee', 'Wähle den Schneehintergrund'],
    ['Wählen Sie einen Namenshintergrund', 'Wähle die Farbe des Namensschilds'],
    ['Wählen Sie fallenden Schnee', 'Wähle den Schneefall'],
    ['Wählen Sie Schriftart', 'Wähle deine Schriftart'],
    ['Wählen Sie Design', 'Wähle deine Dekoration'],
    ['Produkt gestalten', 'Gestalte dein persönliches Geschenk'],
    ['In den Einkaufswagen', 'In den Warenkorb'],
    ['Prev', 'Vorheriges Bild'],
    ['Next', 'Nächstes Bild']
  ];
  personalization.forEach(([from, to]) => words.set(from, to));
  for (let n = 1; n <= 5; n++) words.set('Font ' + n, 'Schriftart ' + n);
  for (let n = 1; n <= 3; n++) words.set('Style ' + n, 'Stil ' + n);
  words.set('Syle 2', 'Stil 2');
  function update() {
    pending = false;
    document.querySelectorAll('.jdgm-carousel__left-arrow,.jdgm-carousel__right-arrow,.jdgm-carousel-title,.jdgm-write-rev-link,.jdgm-rev__read-more,.jdgm-rev__buyer-badge,.tee-clipart-label__text,.tee-custom-select__placeholder,.tee-custom-select__option,.tee-field__heading > span,.tee-form-header__title,.tee-btn > span').forEach(el => {
      const aria = el.getAttribute('aria-label');
      if (words.has(aria)) el.setAttribute('aria-label', words.get(aria));
      const value = el.textContent.trim();
      if (words.has(value)) el.textContent = words.get(value);
    });
    document.querySelectorAll('#tee-artwork-form [aria-label],#tee-gallery [title]').forEach(el => {
      ['aria-label','title'].forEach(attr => {
        const value = el.getAttribute(attr);
        if (words.has(value)) el.setAttribute(attr, words.get(value));
      });
    });
    document.querySelectorAll('.tee-clipart-label img').forEach(el => {
      const alt = el.getAttribute('alt');
      if (words.has(alt)) el.setAttribute('alt', words.get(alt));
    });
    document.querySelectorAll('.jdgm-carousel-number-of-reviews').forEach(el => {
      const value = el.textContent.trim();
      const match = value.match(/^from ([\d.,]+) reviews?$/i);
      if (match) el.textContent = 'aus ' + match[1] + ' Bewertungen';
    });
  }
  const observer = new MutationObserver(() => {
    if (!pending) { pending = true; window.setTimeout(update, 100); }
  });
  update();
  observer.observe(document.body, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['aria-label','title']});
})();
